import { filter, isEmpty } from "lodash-es"
import { AppConstant } from "../../../../../Assests/AppConstant"

const shouldEnableDoorAssigment = (selectedLoad) => {
    const unscheduled_pos = filter(selectedLoad.unscheduled_pos, (el) => el.status === AppConstant.poStatus.PENDING)
    return !isEmpty(selectedLoad.check_in_time) && isEmpty(unscheduled_pos)
}

export { shouldEnableDoorAssigment }